import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import {
  calculateSingleNewsEstimatedTime,
  formatEstimatedTime,
} from "../helpers";
import { renderTemplateSlideItemPreview } from "../templates";

export default function SortableSlideItem({
  news,
  styleSettings,
  selectedVideoTemplate,
}) {
  const { t } = useTranslation();
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: news.id });

  const estimatedTime = useMemo(() => {
    return calculateSingleNewsEstimatedTime(news);
  }, [news]);

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      className={`bg-white border rounded-lg p-4 cursor-move hover:shadow-lg transition-shadow select-none ${
        isDragging ? "shadow-xl ring-2 ring-blue-500" : ""
      }`}
    >
      <div className="flex flex-col gap-3">
        <div className="text-xs text-gray-500">{t("drag to reorder")}</div>
        <div className="w-full">
          {renderTemplateSlideItemPreview({
            template: selectedVideoTemplate?.name,
            news: news,
            styleSettings: styleSettings,
          })}
        </div>
        {news.voiceText && (
          <div className="text-xs text-gray-600 italic border-l-4 border-empower-500 pl-2 bg-gray-50 rounded-r-md py-2">
            <div className="font-semibold text-gray-700 mb-1">
              {t("voice text")}:
            </div>
            {news.voiceText}
            <div className="text-xs text-gray-500 mt-2">
              {t("estimated video duration")}:{" "}
              <span className="font-semibold">
                {formatEstimatedTime(estimatedTime)}
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
